// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"eed2df84","370":"e4dac2ec","486":"fac09c6f","739":"e4dac2ec","773":"43ba3af1","938":"89e3d6f4"}[chunkId] + ".chunk.css";
};